import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { SettingsDataService } from './settings-data.service';

@Injectable({providedIn: 'root'})
export class SettingsDataLoadedGuard {
  constructor(private settingsData: SettingsDataService, private router: Router) {
  }

  async canActivate(): Promise<boolean | UrlTree> {
    const settingsLoaded = await this.settingsData.loaded();
    if (settingsLoaded) {
      return true;
    }

    return this.router.parseUrl('network-error');
  }

  canActivateChild(): Promise<boolean | UrlTree> {
    return this.canActivate();
  }
}
